__turbopack_context__.v({
  "body": "toast-module__aoLJ-W__body",
  "content": "toast-module__aoLJ-W__content",
  "dismiss": "toast-module__aoLJ-W__dismiss",
  "error": "toast-module__aoLJ-W__error",
  "icon": "toast-module__aoLJ-W__icon",
  "success": "toast-module__aoLJ-W__success",
  "title": "toast-module__aoLJ-W__title",
  "toast": "toast-module__aoLJ-W__toast",
  "toastIn": "toast-module__aoLJ-W__toastIn",
  "toaster": "toast-module__aoLJ-W__toaster",
  "warning": "toast-module__aoLJ-W__warning",
});
